import React, { Context } from 'react';

import { VolatileSettingsContextData } from '../types/internal';

export const VolatileSettingsContext: Context<VolatileSettingsContextData> = React.createContext<VolatileSettingsContextData>([
  {
    isComparisonTablePopupVisible: false,
    isAppLoadingVisible: false,
    searchPopupSettings: null,
  },
  (): void => undefined,
]);
